import { useFrame } from '@react-three/fiber';
import gsap from 'gsap';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Group, PlaneGeometry } from 'three';

import IndicationRings, {
  IndicationRingsRef,
} from '0_canvas/IndicationRings/IndicationRings';
import { INDICATION_RINGS_STAGE, useThreeStore } from 'state/threeStore';
import type { GroupProps } from 'types/r3f';

import useMatrixUpdateHandler from 'hooks/useMatrixUpdateHandler';

const IndicationRingsScene = forwardRef<Group, GroupProps>((props, ref) => {
  const indicationRingsRef = useRef<IndicationRingsRef>(null);
  const groupRef = useRef<Group>(null!);
  const stageRef = useRef<INDICATION_RINGS_STAGE>('HIDDEN');

  useImperativeHandle(ref, () => groupRef.current);

  useFrame(() => {
    groupRef.current.visible =
      useThreeStore.getState().indicationRings.isRendered;
  });

  useFrame(() => {
    const { stage } = useThreeStore.getState().indicationRings;

    if (stageRef.current === stage) return;
    stageRef.current = stage;

    if (!indicationRingsRef.current) return;
    gsap.to(indicationRingsRef.current.opacity, {
      value: Number(stage === 'VISIBLE'),
      duration: 2,
    });
  });

  useMatrixUpdateHandler(
    () => useThreeStore.getState().indicationRings.isRendered,
    groupRef.current
  );

  return (
    <group ref={groupRef} {...props}>
      <IndicationRings
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, 1, 0]}
        geometry={new PlaneGeometry(25, 25, 64, 64)}
        thickness={0.01}
        ref={indicationRingsRef}
      />
    </group>
  );
});

IndicationRingsScene.displayName = 'IndicationRingsScene';
export default IndicationRingsScene;
